const gs = {
  showLoader: (status) => {
    let elem = document.getElementsByClassName("loaderBig");

    if (elem) {
      if (status) {
        elem[0].classList.add("show");
      } else {
        elem[0].classList.remove("show");
      }
    }
  },
  debounce: (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  },
};

export default gs;
